import { useState } from "react";

import { Contact } from "lucide-react";
import toast from "react-hot-toast";

import ShimmerButton from "@/components/magicui/shimmer-button";
import { api, cn, handleApiRequest } from "@/lib/utils";
import type { WebsiteWithConversionsLocationsImages } from "@/types/prisma";

export default function ContactAddButton({
  website,
  className,
}: {
  website: WebsiteWithConversionsLocationsImages;
  className?: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = async () => {
    await handleApiRequest({
      makeRequest: async () => {
        setIsLoading(true);
        const response = await api.get(`/api/sites/subdomains/${website.subdomain}/vcard`, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], { type: "text/vcard" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${website.companyName} Contact Card.vcf`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return response.data;
      },
      finallyCallback: () => {
        setIsLoading(false);
      },
    });
  };

  return (
    <ShimmerButton onClick={handleClick} className={cn("flex items-center justify-center gap-2", className)}>
      <Contact className="w-5 h-5" />
      {isLoading ? "Saving Contact" : "Save to Contacts"}
    </ShimmerButton>
  );
}
